// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * LCC API
 * API for the LCC backend
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ValueOverride
 */
export interface ValueOverride {
    /**
     * 
     */
    browsePath?: string;
    /**
     * The override value
     */
    value?: any | null;
    /**
     * 
     */
    dataType?: string;
    /**
     * 
     */
    referenceType?: ValueOverrideReferenceTypeEnum;
    /**
     * 
     */
    updatedAt?: Date;
}


/**
 * @export
 */
export const ValueOverrideReferenceTypeEnum = {
    Property: 'property',
    Variable: 'variable'
} as const;
export type ValueOverrideReferenceTypeEnum = typeof ValueOverrideReferenceTypeEnum[keyof typeof ValueOverrideReferenceTypeEnum];


/**
 * Check if a given object implements the ValueOverride interface.
 */
export function instanceOfValueOverride(value: object): value is ValueOverride {
    return true;
}

export function ValueOverrideFromJSON(json: any): ValueOverride {
    return ValueOverrideFromJSONTyped(json, false);
}

export function ValueOverrideFromJSONTyped(json: any, ignoreDiscriminator: boolean): ValueOverride {
    if (json == null) {
        return json;
    }
    return {
        
        'browsePath': json['browsePath'] == null ? undefined : json['browsePath'],
        'value': json['value'] === undefined ? undefined : json['value'] === null ? null : json['value'],
        'dataType': json['dataType'] == null ? undefined : json['dataType'],
        'referenceType': json['referenceType'] == null ? undefined : json['referenceType'],
        'updatedAt': json['updatedAt'] == null ? undefined : (new Date(json['updatedAt'])),
    };
}

export function ValueOverrideToJSON(json: any): ValueOverride {
    return ValueOverrideToJSONTyped(json, false);
}

export function ValueOverrideToJSONTyped(value?: ValueOverride | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'browsePath': value['browsePath'],
        'value': value['value'],
        'dataType': value['dataType'],
        'referenceType': value['referenceType'],
        'updatedAt': value['updatedAt'] == null ? value['updatedAt'] : value['updatedAt'].toISOString(),
    };
}

